module.exports = __webpack_public_path__ + "img/us.d72324f5.svg";